//#region imports
//#endregion
//#region interfaces

import React, { useState, useEffect } from "react";
import {
  AbfahrtIcon,
  ArbeitsplanType,
  Info,
  WorkPlanContainer,
} from "../utils/types";
import { filterAnkundigungen } from "./arbeitsplan/ArbeitsplanFilter";
import { KachelBox } from "./common/KachelBox";
import { Grid, Typography } from "@mui/material";
import { ArbeitsplanTitleWithUnderline } from "./common/ArbeitsplanTitleWithUnderline";
import moment from "moment";

//#endregion

interface AnkundigungenProps {
  data: ArbeitsplanType[];
}

const Ankundigungen: React.FC<AnkundigungenProps> = ({ data }) => {
  const [ankundigungen, setAnkundigungen] = useState<ArbeitsplanType[]>([]);

  useEffect(() => {
    setAnkundigungen(filterAnkundigungen(data));
  }, [data]);
  return (
    <>
      {ankundigungen?.length > 0 ? (
        <KachelBox title="" isExpanded={true} setIsExpanded={() => {}}>
          {ankundigungen.map((ank, index) => (
            <Grid item xs={12} md={12} key={index}>
              <WorkPlanContainer>
                <ArbeitsplanTitleWithUnderline
                  title={moment(ank.datum).format("DD.MM.YYYY")}
                />
                <Info>
                  <div>
                    <AbfahrtIcon />
                    {ank.zeitvon.replace(new RegExp(":[0-9]*.0000000"), "")}
                    {" - "}
                    {ank.zeitbis.replace(new RegExp(":[0-9]*.0000000"), "")}
                  </div>
                  {ank.bemerkung?.split("\\n").map((line, index) => (
                    <React.Fragment key={index}>
                      {line}
                      <br />
                    </React.Fragment>
                  ))}
                </Info>
              </WorkPlanContainer>
            </Grid>
          ))}
        </KachelBox>
      ) : (
        <Typography sx={{ marginBottom: "20px" }}>
          Aktuell gibt es keine Ankündigungen.
        </Typography>
      )}
    </>
  );
};

export default Ankundigungen;
